import { UserProfileData } from "./types";

export const enum UserDataActionKind {
  UPDATEMULTIPLEFILEDS = "update_multiple_fields",
  UPDATEFIELD = "update_field",
}

export type UserDataAction =
  | {
      type: UserDataActionKind.UPDATEMULTIPLEFILEDS;
      payload: Partial<UserProfileData>;
    }
  | {
      type: UserDataActionKind.UPDATEFIELD;
      key: keyof UserProfileData;
      value: any;
    };

export interface UserDataContextType {
  state: UserProfileData;
  updateMultipleFields(payload: Partial<UserProfileData>): void;
  updateField(key: keyof UserProfileData, value: any): void;
}

export function userDataReducer(
  state: UserProfileData,
  action: UserDataAction
) {
  switch (action.type) {
    case UserDataActionKind.UPDATEMULTIPLEFILEDS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UserDataActionKind.UPDATEFIELD: {
      return {
        ...state,
        [action.key]: action.value,
      };
    }
    default:
      return state;
  }
}
